import { useTranslation } from 'react-i18next';

import { useNavigation } from '@hotjar/navigation/src/hooks/useNavigation';
import { RoundIconButton } from '../RoundButton';
import { BaseIcon } from '@hotjar/hotsauce';

interface InviteMembersProps {
  onClick: () => void;
  className?: string;
}

export const InviteMembers = ({ className, onClick }: InviteMembersProps): JSX.Element => {
  const { t } = useTranslation('navigation');
  const { buildHrefFromRoute, routes } = useNavigation();

  const description = t('InviteMembers.tooltipText');

  return (
    <RoundIconButton
      icon={<BaseIcon icon="user_add" pixelSize={20} />}
      as="a"
      href={buildHrefFromRoute(routes.TEAM.INVITE.path)}
      description={description}
      tooltipText={description}
      kind="ghost"
      className={className}
      onClick={onClick}
    />
  );
};
